module.exports = __webpack_public_path__ + "img/profile-2.19704aca.png";